module.exports = __webpack_public_path__ + "img/BG-5.fd9c77b.png";